import React, { useState } from 'react';
import { Box, Tabs, Tab, Paper, Typography } from '@mui/material';
import OTTPhysicalServer from '../physicalServer';
import MediaServer from './Mediaserver';
import ApplicationServer from './ApplicationServer';

const Servers = () => {
  const [tabValue, setTabValue] = useState(0);

  const handleChange = (
    event: React.SyntheticEvent,
    newValue: number
  ) => {
    setTabValue(newValue);
  };

  return (
    <Box sx={{ p: 3 }}>
      {/* Tabs */}
      <Paper elevation={2} sx={{bgcolor:"transparent",boxShadow: "none"}}>
        <Tabs
          value={tabValue}
          onChange={handleChange}
          textColor="primary"
          indicatorColor="primary"
          
        >
          <Tab label="Stream Servers" />
          <Tab label="Media Servers" />
          <Tab label="Application Servers" />
        </Tabs>
      </Paper>

      {/* Tab 1 Content */}
      {tabValue === 0 && (
        <Box>
          <OTTPhysicalServer/>
        </Box>
      )}

      {/* Tab 2 Content */}
      {tabValue === 1 && (
        <Box>
          <MediaServer/>
        </Box>
      )}

      {tabValue === 2 && (
        <Box>
          <ApplicationServer/>
        </Box>
      )}
    </Box>
  );
};

export default Servers;